import type { LocaleCode } from '@/i18n/locales'
import type { CalculatorsOverviewLocaleContent } from '../types'
import { calculatorsOverviewEn } from './en'
import { calculatorsOverviewEs } from './es'

const contentByLocale: Partial<Record<LocaleCode, CalculatorsOverviewLocaleContent>> = {
  en: calculatorsOverviewEn,
  es: calculatorsOverviewEs,
}

export function getCalculatorsOverviewContent(locale: LocaleCode): CalculatorsOverviewLocaleContent {
  return contentByLocale[locale] ?? calculatorsOverviewEn
}
